import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_427: DocMigration = {
  maxSchemaVersion: "0.0.427",
  description: "Add custom global parameters",
  apply(json: any) {
    // add global parameters table
    json.globalParameters = {};

    for (const parameterId in json.parameters) {
      json.parameters[parameterId].entityType = "LOCAL_PARAMETER";
    }

    // rename parameters table
    json.localParameters = json.parameters ?? {};
    delete json.parameters;

    return json;
  },
};

export default migration_0_0_427;
